export default {"src":"/_next/static/media/icon-social-instagram-white.6672578f.svg","height":23,"width":23};